    angular.module('eStories.howItWorks', [])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.howItWorks', {
                url: 'howItWorks',
                views: {
                    'mainView@': {
                        templateUrl: 'home/howItWorks/howItWorks.tmpl.html',
                        controller: 'HowItWorksCtrl',
                        controllerAs: 'howItWorksCtrl'
                    }
                }
            });
    }])
    .controller('HowItWorksCtrl', ['CarouselService', 'AccountModel', 'SeoModel', '$location', 'GA',
        function (CarouselService, AccountModel, SeoModel, $location, GA) {

        var howItWorksCtrl = this;

        GA.trackPageView($location.path());

        SeoModel.applyMetaTags("eStories.navbars.howItWorks");

        howItWorksCtrl.audiobookIdArray = [74071, 92866, 23744];

        howItWorksCtrl.setCurrentAudiobookCover = function (index) {
            var indexObj = CarouselService.setIndexes(index, howItWorksCtrl.audiobookIdArray.length);
            howItWorksCtrl.currentIndex = indexObj.currentIndex;
            howItWorksCtrl.previousIndex = indexObj.previousIndex;
            howItWorksCtrl.nextIndex = indexObj.nextIndex;
        };

        howItWorksCtrl.setCurrentAudiobookCover(0);

        howItWorksCtrl.getArrayValue = function (index) {
            return "/eStories/rest/catalog/getAudiobookCover?width=450&audiobookId=" + howItWorksCtrl.audiobookIdArray[index];
        };

        howItWorksCtrl.showHowItWorksSignUpModal = function () {
            AccountModel.signUpOrConfirmTrial();
        };

    }]);